module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/05_shape-sm-12861a25fd3ab739577c41e4beb8f410.png";